import GeneralModal from "../../GeneralModal";
import { ProcessView } from "@prisma/client";
import { useRouter } from "next/router";
import React from "react";
import { toast } from "react-toastify";
import { trpc } from "utils/trpc";

interface Props {
  setModalVisible: (_: boolean) => void;
  modalVisible: boolean;
  signalView: ProcessView;
}

export default function SignalViewDeleteModal({ setModalVisible, modalVisible, signalView }: Props) {
  const router = useRouter();
  const utils = trpc.useContext();
  const { mutateAsync: deleteSignalView, isLoading } = trpc.processViews.delete.useMutation({
    onSuccess: async () => {
      router.push("/signals");
      await utils.processViews.list.invalidate();
      await utils.processViews.get.invalidate({ processViewId: signalView.id });
      setModalVisible(false);
      toast.success("View successfully deleted!");
    },
  });

  return (
    <GeneralModal
      isLoading={isLoading}
      setModalVisible={setModalVisible}
      modalVisible={modalVisible}
      title={`Delete the view "${signalView.title}" from organization?`}
      description="You cannot undo this action."
      onConfirm={() => deleteSignalView({ processViewId: signalView.id })}
      confirmDanger={true}
    />
  );
}
